import * as muColors from '@material-ui/core/colors';

import {blackAlpha, whiteAlpha} from './alpha';
import {black, gray, white} from './shades';
import {
  facebook,
  linkedin,
  messenger,
  telegram,
  twitter,
  whatsapp,
} from './social';

export const colors = {
  ...muColors, // Default material UI colors

  transparent: 'transparent',
  current: 'currentColor',
  black,
  white,

  whiteAlpha,
  blackAlpha,
  gray,

  messenger,
  twitter,
  linkedin,
  whatsapp,
  facebook,
  telegram,
};

export type Colors = typeof colors;
